.react-datepicker-wrapper {
  width: 100%;
}
.custom-datepicker-input {
  width: 100%;
  padding: 10px 36px 10px 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: white;
  color: #000;
  box-sizing: border-box;
}
.react-datepicker-popper {
  z-index: 9999 !important;
}
.custom-date-wrapper {
  position: relative;
  width: 100%;
}
.custom-date-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #555;
}

.age-confirm-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  cursor: pointer;
  user-select: none;
}
.age-confirm-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  margin: 0;
}
.age-confirm-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid #ccc;
  background-color: #fff;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease;
  flex-shrink: 0;
}
.age-confirm-row:hover .age-confirm-box {
  border-color: #0a7ea4;
}
.age-confirm-input:focus-visible + .age-confirm-box {
  box-shadow: 0 0 0 3px rgba(10, 126, 164, 0.25);
  border-color: #0a7ea4;
}
.age-confirm-box--checked,
.age-confirm-row:hover .age-confirm-box--checked {
  background-color: #0a7ea4;
  border-color: #0a7ea4;
}
.age-confirm-check {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}
